import type { SearchFiltersByName } from '#/modules/search/types/FiltersByName/SearchFiltersByName';
import type { SearchType } from '#/modules/search/types/SearchType';

import { hasDateRange } from './hasDateRange';

type Args = {
  searchType: SearchType;
  query: string;
  filters: SearchFiltersByName;
};

// Single source of truth for whether sort options should be shown, shared by
// the desktop results header and the mobile filter modal (sc-67240). Sorting
// only applies to query-based results; Event/Volop searches additionally hide
// sort when a date range is active, since those results are date-ordered.
export function searchShouldShowSortOptions({
  searchType,
  query,
  filters,
}: Args): boolean {
  if (!query) return false;
  if (searchType === 'EVENT' || searchType === 'VOLOP')
    return !hasDateRange(filters);
  return true;
}
